import { c as _c } from "react/compiler-runtime";
// ── useCopySupportId — shared clipboard logic for the Support ID ────────────
// Extracted so every Support ID affordance (the full labeled row, the
// icon-only button) shares one clipboard implementation. No shared
// `useCopyToClipboard` hook exists elsewhere in the repo — the 4 other
// clipboard call sites (platform contextzen x3, data-enrichment x1) each
// inline `navigator.clipboard` independently. Ref: ASC-6756.

import { useEffect, useRef, useState } from 'react';

// 1500ms matches the repo's existing copy-feedback convention (3 of 4 other
// clipboard call sites — ProcessedFactsTab, MessageBubble, ReviewItemDetailDrawer).
const REVERT_DELAY_MS = 1500;
export type CopyStatus = 'idle' | 'copied' | 'failed';
export function useCopySupportId(supportId) {
  const $ = _c(8);
  const [copyStatus, setCopyStatus] = useState("idle");
  const revertTimeoutRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => () => {
      if (revertTimeoutRef.current !== null) {
        clearTimeout(revertTimeoutRef.current);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function settleStatus(status) {
      setCopyStatus(status);
      if (revertTimeoutRef.current !== null) {
        clearTimeout(revertTimeoutRef.current);
      }
      revertTimeoutRef.current = setTimeout(() => setCopyStatus("idle"), REVERT_DELAY_MS);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const settleStatus = t2;
  let t3;
  if ($[3] !== supportId) {
    t3 = function handleCopyClick() {
      try {
        navigator.clipboard.writeText(supportId).then(() => settleStatus("copied"), () => settleStatus("failed"));
      } catch {
        settleStatus("failed");
      }
    };
    $[3] = supportId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCopyClick = t3;
  let t4;
  if ($[5] !== copyStatus || $[6] !== handleCopyClick) {
    t4 = {
      copyStatus,
      handleCopyClick
    };
    $[5] = copyStatus;
    $[6] = handleCopyClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}